import { useParams } from '@dreamstack/feature-components/src/hooks/useParams'
import { useLocale } from '@dreamstack/i18n'
import { trpc } from '@dreamstack/trpc/client'

export const useNewsArticleData = () => {
  const { slug } = useParams()
  const locale = useLocale()

  const { data } = trpc.cms.getNewsArticle.useQuery(
    { locale, slug },
    {
      trpc: { ssr: true },
      staleTime: Infinity,
    }
  )

  if (!data) return null

  return data
}
